import { createSlice } from '@reduxjs/toolkit';

export const loginSlice = createSlice({
  name: 'login',
  initialState: {
    token: null,
    user: null,
    activeMenukey: ['1'],
  },
  reducers: {
    updateToken: (state, { payload }) => {
      state.token = payload.token;
    },
    updateUser: (state, { payload }) => {
      state.user = payload.user;
    },
    logout: (state) => {
      state.token = null;
      state.user = null;
    },
    updateActiveMenuKey: (state, { payload: { menuKey } }) => {
      state.activeMenukey = [`${menuKey}`];
    },
  },
});

export const {
  updateToken,
  updateUser,
  logout,
  updateActiveMenuKey,
} = loginSlice.actions;

export default loginSlice.reducer;
